// Mirrors MARKER_NOTE_CONTENT_MAX_LENGTH on the server.
export const NOTE_CONTENT_MAX_LENGTH = 2000;

// The field starts this tall and grows with the text up to its max height, then scrolls.
export const NOTE_FIELD_MIN_ROWS = 3;

// The remaining-characters count only shows once the text gets this close to the limit.
export const NOTE_COUNTER_THRESHOLD = 200;
